const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20romance%20manhwa%20banner%20art%2C%20beautiful%20couple%20silhouette%20against%20sunset%20cityscape%2C%20Korean%20webtoon%20cinematic%20style%2C%20warm%20coral%20and%20gold%20gradient%2C%20elegant%20composition%2C%20soft%20dreamy%20atmosphere%2C%20professional%20illustration&width=1200&height=600&seq=carousel-manga-01&orientation=landscape',
    title: '社内相亲',
    subtitle: '韩漫恋爱天花板',
    desc: '平凡上班族与完美社长的契约恋爱，从互相嫌弃到真心相爱，全程甜到牙疼。女神漫画下拉式全集免费畅读，一口气追完120话不费劲。',
    tag: '本周主打',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20action%20manhwa%20banner%2C%20lone%20hunter%20standing%20before%20massive%20dungeon%20gate%2C%20Korean%20webtoon%20style%2C%20dramatic%20lighting%2C%20warm%20dark%20tones%2C%20epic%20scale%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-manga-02&orientation=landscape',
    title: '我独自升级',
    subtitle: '奇幻战斗巅峰之作',
    desc: '从人类最弱到世界最强，济州岛突袭篇正式开启！影之军团全数出击，女神漫画下拉式滚动看战斗场面，每一格都燃到炸裂。',
    tag: '连载热追',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20school%20life%20manhwa%20banner%2C%20girls%20in%20school%20uniform%20laughing%20together%2C%20Korean%20webtoon%20style%2C%20bright%20warm%20sunlight%2C%20youthful%20energy%2C%20soft%20pastel%20colors%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-manga-03&orientation=landscape',
    title: '女神降临',
    subtitle: '校园逆袭经典',
    desc: '化妆改变命运的校园故事，又好笑又好哭。女神漫画下拉式全集已完结，216话一口气刷完，带你重温学生时代的心动与感动。',
    tag: '口碑精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20manga%20banner%2C%20spy%20family%20posing%20together%20in%20living%20room%2C%20Japanese%20manga%20style%2C%20cozy%20home%20atmosphere%2C%20soft%20warm%20lighting%2C%20heartwarming%20composition&width=1200&height=600&seq=carousel-manga-04&orientation=landscape',
    title: '间谍过家家',
    subtitle: '日漫温馨喜剧',
    desc: '间谍父亲、杀手母亲、读心术女儿，三人互相隐瞒身份组成的伪装家庭，却比真实家庭更温暖。女神漫画下拉式日漫全集火热连载中。',
    tag: '日漫推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fairy%20tale%20fantasy%20manhwa%20banner%2C%20princess%20in%20magnificent%20palace%20ballroom%2C%20Korean%20webtoon%20style%2C%20dreamy%20golden%20lighting%2C%20ornate%20details%2C%20elegant%20atmosphere%2C%20cinematic%20wide%20angle&width=1200&height=600&seq=carousel-manga-05&orientation=landscape',
    title: '某天成为公主',
    subtitle: '穿越宫廷名作',
    desc: '一觉醒来变成童话里的公主？还是注定悲剧的那种？看女主角如何凭智慧和魅力改写命运。女神漫画下拉式全集画风绝美必收藏。',
    tag: '画风绝美',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20demon%20slayer%20manga%20banner%2C%20warriors%20with%20swords%20facing%20demons%2C%20Japanese%20manga%20style%2C%20dramatic%20warm%20lighting%2C%20intense%20action%20scene%2C%20cinematic%20composition%2C%20epic%20scale&width=1200&height=600&seq=carousel-manga-06&orientation=landscape',
    title: '鬼灭之刃',
    subtitle: '日漫热血神作',
    desc: '大正时代的灭鬼物语，炭治郎与祢豆子的兄妹羁绊感动全球。女神漫画下拉式全集完整收录，每一个战斗场面都震撼人心。',
    tag: '经典必读',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">编辑精选</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式编辑团队用心甄选，每部都是精品</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-[220px] lg:w-[260px] aspect-[2/1] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 sm:p-5 flex-1 flex flex-col justify-center">
                <p className="text-xs text-primary-500 font-medium mb-1">{item.subtitle}</p>
                <h3 className="text-lg font-heading text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}